module.exports = __webpack_public_path__ + "static/media/a45.1a792f92.jpg";